import * as yup from "yup"
import {
  requiredErrorMessage,
} from "../../formItems/errors/yupErrorMessages"

export const editExamGroupValidationSchema = yup.object().shape({
  name: yup.string().required(requiredErrorMessage),
  tenant: yup.string().required(requiredErrorMessage)
})
